module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "CN",
    attrs: {
      "id": "_idParaDest-4"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "CR"
  }, [_vm._v("Copyright © 2010 by Lily King")]), _vm._v(" "), _c('p', {
    staticClass: "CRspace"
  }, [_vm._v("All rights reserved. No part of this book may be reproduced in any form or by any electronic or mechanical means, including information storage and retrieval systems, without permission in writing from the publisher, except by a reviewer, who may quote brief passages in a review. Scanning, uploading, and electronic distribution of this book or the facilitation of such without the permission of the publisher is prohibited. Please purchase only authorized electronic editions, and do not participate in or encourage electronic piracy of copyrighted materials. Your support of the author’s rights is appreciated. Any member of educational institutions wishing to photocopy part or all of the work for classroom use, or anthology, should send inquiries to Grove Atlantic, 154 West 14th Street, New York, NY 10011 or "), _c('a', {
    attrs: {
      "href": "mailto:permissions@groveatlantic.com"
    }
  }, [_vm._v("permissions@groveatlantic.com")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "CRspace"
  }, [_vm._v("My deepest gratitude to my husband and very first reader, Tyler Clements, and to Susan Conley, Sara Corbett, Caitlin Gutheil, Anja Hanson, Debra Spark, Liza Bakewell, Wendy Weil, Deb Seager, Morgan Entrekin, Eric Price, Jessica Monahan, Lisa King, Apple King, and my mother; and to my beloved daughters, who put up with all this. A special, devotional thank you to my extraordinary editor, Elisabeth Schmitz.")]), _vm._v(" "), _c('p', {
    staticClass: "CRspace"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Published simultaneously in Canada")])]), _vm._v(" "), _c('p', {
    staticClass: "CR"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Printed in Canada")])]), _vm._v(" "), _c('p', {
    staticClass: "CRspace"
  }, [_vm._v("First Grove Atlantic hardcover edition: June 2010")]), _vm._v(" "), _c('p', {
    staticClass: "CR"
  }, [_vm._v("First Grove Atlantic paperback edition: April 2011")]), _vm._v(" "), _c('p', {
    staticClass: "CR"
  }, [_vm._v("This Grove Atlantic edition: November 2022")]), _vm._v(" "), _c('p', {
    staticClass: "CRspace"
  }, [_vm._v("This book was set in 11.25-pt. Bembo by Alpha Design & Composition of Pittsfield, NH")]), _vm._v(" "), _c('p', {
    staticClass: "CRspace"
  }, [_vm._v("ISBN 978-0-8021-6029-4")]), _vm._v(" "), _c('p', {
    staticClass: "CR"
  }, [_vm._v("eISBN 978-0-8021-9708-5")]), _vm._v(" "), _c('p', {
    staticClass: "CRspace"
  }, [_vm._v("Grove Press")]), _vm._v(" "), _c('p', {
    staticClass: "CR"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("an imprint of Grove Atlantic")])]), _vm._v(" "), _c('p', {
    staticClass: "CR"
  }, [_vm._v("154 West 14th Street")]), _vm._v(" "), _c('p', {
    staticClass: "CR"
  }, [_vm._v("New York, NY 10011")]), _vm._v(" "), _c('p', {
    staticClass: "CRspace ParaOverride-3"
  }, [_vm._v("Distributed by Publishers Group West")]), _vm._v(" "), _c('p', {
    staticClass: "CRspace ParaOverride-3"
  }, [_c('a', {
    attrs: {
      "href": "http://groveatlantic.com",
      "target": "_blank"
    }
  }, [_vm._v("groveatlantic.com")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5bb030c3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/97808021970853.vue
// module id = 72
// module chunks = 0